<template>
    <div class="container">
    
    <project-header 
      :project="projectInfo" 
      :user="user" 
      :is_owner_seller="ownerSeller" 
      :seller_complete="seller_complete" 
      @update-project="updateProject" 
      ref="ProjectHeader"></project-header>
          
    <b-card no-body>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Description" title-link-class="darklink">
          <b-card-text>
              <project-description :project="projectInfo" :user="user"></project-description>
          </b-card-text>
        </b-tab>
        <b-tab title="Service Provider" title-link-class="darklink" v-if="ownerSeller">
            <b-card-text>
              <project-sp :project="projectInfo" :user="user" ref="ProjectSP"></project-sp>
              </b-card-text>
          </b-tab>
        <b-tab title="Messages" title-link-class="darklink" v-if="ownerSeller">
          <b-card-text>
            <project-messages :project="projectInfo" :user="user" ref="ProjectMessages"></project-messages>
            </b-card-text>
        </b-tab>
        <b-tab title="Updates" title-link-class="darklink" v-if="ownerSeller">
          <b-card-text>
            <project-updates :project="projectInfo" :user="user" ref="ProjectUpdates"></project-updates>
            </b-card-text>
        </b-tab>
        <b-tab title="Files" title-link-class="darklink" v-if="ownerSeller">
          <b-card-text>
            <project-files :project="projectInfo" :user="user"></project-files>
            </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>

  <delete-project v-if="projectInfo.status == 'Waiting for quote' && 
                  user.id == projectInfo.user_id" :project="project"></delete-project>

</div>
</template> 

<script>
export default {
  props: ['user','project','tab','is_owner_seller','seller_complete'],

  data() {
    return {
      tabIndex: 0,
      projectInfo: {},
      ownerSeller: false,
    };
  },

  created() {
    if (this.tab) {
      this.tabIndex = this.tab;
    }
    
    this.ownerSeller = this.is_owner_seller;
    this.projectInfo = this.project;

    Echo.private('project_' + this.project.id)
      .listen("UpdateProject", (event) => {
        
        // check if logged in user is owner or seller
        if (this.user.id == event.message.data.user_id || this.user.id == event.message.data.seller_id) {
          this.ownerSeller = true;
        } else {
          this.ownerSeller = false;
        }
        this.updateProject(event.message.data);
      });

  },

  methods: {
      
      updateProject(data) {
        this.projectInfo = data;
        this.$refs.ProjectHeader.updateProject(data);
        // this.$refs.ProjectUpdates.getUpdates();
        // this.$refs.ProjectSP.getProfile(data.seller_id);
        // this.$refs.ProjectMessages.setProjectInfo(data);
      },
  
    },

};
</script>